import styled from "styled-components";

export const InputContainerStyled = styled.div`
  width: 100%;
  height: 100%;
  
  .container-add{
    display: flex;
    flex-direction: row;
    gap: 0.5em;
  }
  .container-list{
    margin-top: 5%;
  }
`;
